<template>
  <div>
    <div
      :class="
        path === '/home' ||
        path === '/editeProfile' ||
        path === '/specialtylife' ||
        path === '/about' ||
        path === '/meeting' ||
        path === '/filemeeting' ||
        path === '/favorite' ||
        path === '/opinion' ||
        path === '/movie' ||
        path === '/contactus' ||
        path === '/opinionuser' ||
        path === '/payment' ||
        path === '/categoryLearn' ||
        path === '/viewcategory' ||
        path === '/specialtylife' ||
        path == 'helpvideo'
          ? 'headerPage'
          : path === '/login'
          ? 'headerPage2'
          : path === '/chat'
          ? 'headerChats headerPage'
          : 'header-second headerPage'
      "
    >
      <ul>
        <li v-if="path === '/filemeeting'"></li>
        <li class="nav-icon">
          <v-app-bar-nav-icon
            v-if="iconDrawer"
            @click.stop="drawer = !drawer"
          ></v-app-bar-nav-icon>
          <v-btn v-if="arrow_forward" @click="$router.go(-1)">
            <v-icon>arrow_forward</v-icon>
          </v-btn>
        </li>
        <li class="titlePage">
          <span v-if="titles">{{ title }}</span>
        </li>
        <li v-if="backPage" class="backPage">
          <v-btn @click="$router.go(-1)">
            <span> بازگشت</span>
            <v-icon>keyboard_arrow_left</v-icon>
          </v-btn>
        </li>

        <li v-if="search" class="searchProduct" @click="handelSearch">
          <v-icon color="#0000CD">search</v-icon>
        </li>
        <li
          v-if="
            path === '/specialtylife' ||
              path === '/categoryLearn' ||
              path === '/movie' ||
              path === '/filemeeting'
          "
          class="likeapp"
        >
          <v-btn @click="onClickChildFave">
            <v-icon v-if="!like">favorite_border</v-icon>
            <v-icon v-else>favorite</v-icon>
          </v-btn>
        </li>
        <li
          v-if="
            path === '/editeProfile' ||
              path === '/favorite' ||
              path === '/chat' ||
              path === '/about' ||
              path === '/specialtylife' ||
              path === '/opinion' ||
              path === '/payment' ||
              path === '/viewcategory' ||
              path === '/categoryLearn' ||
              path === '/opinionuser' ||
              path === '/meeting' ||
              path === '/filemeeting' ||
              path === '/movie' ||
              path === '/login' ||
              path === '/helpvideo' ||
              path === '/pageQuestion' ||
              path === '/listQuestion' ||
              path === '/stratQuestion' ||
              path === '/singleQuestion' ||
              path === '/seeresult' ||
              path === '/contactus'
          "
          class="back-page styl"
        >
          <v-btn @click="$router.go(-1)">
            <v-icon>arrow_back_ios</v-icon>
          </v-btn>
        </li>
      </ul>
      <div v-if="search" :class="['searchBox', activeSearch && 'activeSearch']">
        <v-text-field
          label="جستجو آموزه های پیوند عقل و عشق  ..."
          solo
          hide-details="auto"
          height="100%"
          v-model="search_input"
          @change="typing()"
        ></v-text-field>
        <v-icon @click="handelCloseSearch">close</v-icon>
      </div>
      <div :class="['seaerchResult', activeSearch && 'showResult']">
        <v-card
          class="box-favorite2 itemResult"
          style="display: flex"
          width="90%"
          @click="GoTOSub(item)"
          v-for="(item, index) in dataSearch"
          :key="index"
        >
          <div class="content-favorite-category2" v-if="item.content_type == 1">
            <div class="img-favorite2">
              <img :src="item.content_poster" alt="" />
            </div>
            <div class="title-favorite2">
              <span>{{ item.content_title }}</span>
              <span>{{ item.content_voters }} بازدید</span>
            </div>
          </div>
          <div
            class="l-content-favorite-category2"
            v-if="item.content_type == 1"
          >
            <span>بخش آموزشی</span>
          </div>

          <div
            class="r-box-favorite2"
            v-if="item.content_type == 0"
            :style="item.content_type == 0 ? 'border: unset !important' : ''"
          >
            <div class="bck-img-boxs2">
              <div class="img-boxs-favorite2">
                <img
                  :src="
                    item.content_format == 0
                      ? require('../../assets/image/icon_play.png')
                      : item.content_format == 1
                      ? require('../../assets/image/icon_play_voice.png')
                      : item.content_format == 2
                      ? require('../../assets/image/icon_play_image.png')
                      : item.content_format == 3
                      ? require('../../assets/image/icon_pdf.png')
                      : item.content_format == 4
                      ? require('../../assets/image/icon_pdf.png')
                      : ''
                  "
                  alt=""
                />
              </div>
            </div>
            <div class="text-boxs-favorite2">
              <h6>{{ item.content_title }}</h6>
              <span>{{
                item.content_format == 0
                  ? "فایل ویدیویی"
                  : item.content_format == 1
                  ? "فایل صوتی"
                  : item.content_format == 2
                  ? "فایل تصویری"
                  : item.content_format == 3
                  ? "فایل متنی"
                  : item.content_format == 3
                  ? "فایل PDF"
                  : ""
              }}</span>
            </div>
          </div>
          <div class="footer-box-favorite2" v-if="item.content_type == 0">
            <span>{{ item.content_duration }}</span>
            <v-icon>query_builder</v-icon>
          </div>
        </v-card>

        <!--                <div class="itemResult" v-for="item in dataSearch" :key="item.index">-->
        <!--                    <div class="itemResult__image">-->
        <!--                        <img src="../../assets/image/avatar_sample.jpg" alt=""/>-->
        <!--                    </div>-->
        <!--                    <div class="itemResult__title">-->
        <!--                        <h5>{{item.content_title}}</h5>-->
        <!--                        <span></span>-->
        <!--                    </div>-->
        <!--                </div>-->
      </div>
    </div>

    <v-navigation-drawer
      v-model="drawer"
      absolute
      right
      temporary
      class="mobileDrawer"
    >
      <div class="drawerInfo">
        <div>
          <div class="image-header-mobile">
            <div class="image-user">
              <img :src="user_avatar" alt="" />
            </div>
            <div class="text-header-mobile">
              <span>{{ name }} </span>
              <p>{{ phone }}</p>
            </div>
          </div>
          <v-list nav dense>
            <v-list-item-group
              v-model="group"
              active-class="color-active text--accent-4"
              class="listDrawer"
            >
              <v-list-item to="/home" v-if="path != '/home'">
                <v-icon class="menuIcon">home</v-icon>
                <v-list-item-title> بازگشت به صفحه اصلی</v-list-item-title>
              </v-list-item>

              <v-list-item to="/editeProfile">
                <v-icon class="menuIcon">account_circle</v-icon>
                <v-list-item-title> ویرایش پروفایل</v-list-item-title>
              </v-list-item>

              <!--              <v-list-item>-->
              <!--                <v-icon class="menuIcon">get_app</v-icon>-->
              <!--                <v-list-item-title> دانلود های من </v-list-item-title>-->
              <!--              </v-list-item>-->

              <v-list-item to="/favorite" class="brd-clr">
                <v-icon class="menuIcon">favorite</v-icon>
                <v-list-item-title> مورد علاقه ها</v-list-item-title>
              </v-list-item>

              <!--              <v-list-item @click="ratemodal = true">-->
              <!--                <v-icon class="menuIcon">star_rate</v-icon>-->
              <!--                <v-list-item-title> امتیاز دهید </v-list-item-title>-->
              <!--              </v-list-item>-->

              <v-list-item to="helpvideo">
                <v-icon class="menuIcon">slideshow</v-icon>
                <v-list-item-title> فیلم راهنمای برنامه</v-list-item-title>
              </v-list-item>

              <v-list-item @click="share">
                <v-icon class="menuIcon">share</v-icon>
                <v-list-item-title>اشتراک گذاری برنامه</v-list-item-title>
              </v-list-item>

              <v-list-item to="/chat" class="brd-clr">
                <v-icon class="menuIcon">message</v-icon>
                <v-list-item-title>صندوق پیام</v-list-item-title>
              </v-list-item>

              <v-list-item to="contactus">
                <v-icon class="menuIcon">local_phone</v-icon>
                <v-list-item-title> ارتباط با ما</v-list-item-title>
              </v-list-item>

              <v-list-item to="/about">
                <v-icon class="menuIcon">error_outline</v-icon>
                <v-list-item-title>درباره ما</v-list-item-title>
              </v-list-item>

              <v-list-item @click="logout = true">
                <v-icon class="menuIcon">login</v-icon>
                <v-list-item-title> خروج از حساب کاربری</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </div>
      </div>
    </v-navigation-drawer>

    <v-dialog v-model="logout">
      <v-card class="box-modal">
        <v-card-text class="contentDialog">
          آیا از حساب کاربری خود خارج میشوید؟
        </v-card-text>
        <v-card-actions class="centerBtn btnAction">
          <v-btn class="btn-reject" text @click="OUT()" large>
            بله
          </v-btn>
          <v-btn class="btn-accept" text @click="logout = false" large>
            بازگشت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="ratemodal">
      <v-card class="box-modal">
        <v-card-text class="contentDialog">
          نظرتون راجع به برنامه پیوند عقل و عشق چی هست؟
        </v-card-text>
        <v-card-actions class="centerBtn btnAction">
          <v-btn class="btn-reject" text @click="ratemodal = false" large>
            عالی
          </v-btn>
          <v-btn class="btn-accept" text @click="ratemodal = false" large>
            بد
          </v-btn>
          <v-btn class="btn-accept" text @click="ratemodal = false" large>
            بعدا نظر میدم
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import oracle from "@/oracle";

export default {
  name: "Header",
  props: {
    title: {
      type: String,
      default: "",
    },
    arrow_forward: {
      type: Boolean,
      default: false,
    },
    iconDrawer: {
      type: Boolean,
      default: true,
    },
    store: {
      type: Boolean,
      default: false,
    },

    titles: {
      type: Boolean,
      default: true,
    },
    search: {
      type: Boolean,
      default: true,
    },
    backPage: {
      typeof: Boolean,
      default: false,
    },
  },
  data: () => ({
    drawer: false,
    group: null,
    dialog: false,
    logout: false,
    name: "",
    phone: "",
    user_avatar: "",
    path: "",
    badge_counter: 0,
    activeSearch: false,
    ratemodal: false,
    like: false,
    content_title: "",
    search_input: "",
    dataSearch: [],
  }),
  watch: {
    group() {
      this.drawer = false;
    },
    $route(to) {
      this.path = to.path;
      if (oracle.getToken()) {
        oracle.axios("user/getProfile", null, this.getProfile);
      }
    },
  },
  methods: {
    GoTOSub(item) {
      this.dataSearch = [];
      this.search_input = "";
      this.activeSearch = false;
      if (item.content_type == 0) {
        this.$router.push({ name: "movie", query: { id: item.content_id } });
      } else {
        this.$router.push({
          name: "specialtylife",
          query: { id: item.content_id },
        });
      }
    },
    OUT() {
      oracle.logOut();
      this.logout = false;
    },
    onClickChildFave() {
      this.$root.$emit("fave");
    },
    share() {
      this.shareText = oracle.getData("intro").share_text;
      var textArea = document.createElement("textarea");
      textArea.value = this.shareText;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("Copy");
      // alert("Copied the text: " + textArea.value);
      textArea.remove();
    },

    Getprofile(response) {
      this.name = response.data.username;
      this.phone = response.data.phone;
    },
    handelSearch() {
      this.activeSearch = true;
      // this.search_input
    },
    handelCloseSearch() {
      this.activeSearch = false;
    },
    typing() {
      oracle.axios(
        "content/getList",
        {
          limit_by: 15,
          order_by: "create_at",
          search_by: this.search_input,
          sort_by: "des",
        },
        this.getListSearch
      );
    },
    getListSearch(response) {
      this.dataSearch = response.data;
    },
    getProfile(response) {
      this.name = response.data.username;
      this.phone = response.data.phone;
      this.user_avatar = response.data.user_avatar;
    },
    checkSize() {
      // if (!oracle.isMobile()) {
      //     this.iconDrawer = false
      // }
    },
  },
  created() {
    window.addEventListener("resize", this.checkSize());
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.checkSize());
  },

  mounted() {
    this.checkSize();
    this.path = this.$route.path;
    this.$root.$on("fave_true", () => {
      this.like = true;
    });
    this.$root.$on("fave_false", () => {
      this.like = false;
    });
    this.$root.$on("content_title", (content_title) => {
      this.content_title = content_title;
    });
    this.$root.$on("BIGScreen", () => {
      // this.iconDrawer = false
    });
    if (oracle.getToken()) {
      oracle.axios("user/getProfile", null, this.getProfile);
    }
  },
};
</script>

<style>
.r-box-favorite2 {
  display: flex;
}

.img-boxs-favorite2 {
  width: 40px;
  height: 40px;
}

.img-boxs-favorite2 img {
  width: 100%;
  height: 100%;
}

.bck-img-boxs2 {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  background: #f4f6f6;
  margin: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.box-favorite2 {
  display: flex;
  margin: 0 auto;
  margin-top: 10px;
  justify-content: space-between;
  padding: 5px 0;
  border: 4px solid #fba800 !important;
}

.text-boxs-favorite2 h6 {
  font-size: 13px;
}

.text-boxs-favorite2 span {
  font-size: 12px;
  color: #707070;
}

.text-boxs-favorite2 {
  display: flex;
  flex-direction: column;
  align-self: center;
}

.footer-box-favorite2 {
  font-size: 12px;
  display: flex;
  align-items: flex-end;
  padding: 5px;
}

.footer-box-favorite2 .v-icon {
  font-size: 15px;
}

.content-favorite-category2 {
  display: flex;
}

.l-content-favorite-category2 {
  background: #fba800;
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  font-size: 12px;
  padding: 5px;
}

.img-favorite2 {
  width: 50px;
  height: 50px;
  border-radius: 50px;
  overflow: hidden;
}

.img-favorite2 img {
  width: 100%;
  height: auto;
}

.title-favorite2 span {
  font-size: 14px;
}

.title-favorite2 {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.title-favorite2 span:last-child {
  color: #707070;
  font-size: 12px;
}

/*.v-application .deep-purple--text,
    .v-application .deep-purple--text:focus,
    .v-application .deep-purple--text:active {
      color: #005ea7 !important;
      caret-color: #005ea7 !important;
    } */

.v-application .deep-purple--text.text--accent-4,
.v-application
  .deep-purple--text.text--accent-4:focus
  .v-application
  .deep-purple--text.text--accent-4:active {
  color: #005ea7 !important;
  caret-color: #005ea7 !important;
}

.titleDialog {
  background-color: #005ea7;
  justify-content: center;
  color: #fff;
}

.contentDialog {
  padding: 1em !important;
  text-align: center;
}

.btnAction {
  display: flex;
  justify-content: space-between;
}

.btnAction button {
  letter-spacing: 0 !important;
  border-radius: 10px;
}

.btnAction button span {
  font-size: 12px !important;
}

.btn-reject {
  background-color: #0000cd !important;
  margin-left: 1em;
  border-radius: 5px;
}

.btn-reject span {
  color: #fff !important;
}

.btn-accept {
  background-color: #fff !important;
  color: #707070 !important;
  border-radius: 5px !important;
  font-size: 12px !important;
}

.headerPage2 {
  /*background: url("../../assets/image/background.jpg");*/
  background-color: transparent;
  width: 100%;
  height: 80px;
  padding: 15px 25px;
  background-size: cover;
  z-index: 20;
  position: absolute;
}
.headerChats {
  background: url("../../assets/image/background.jpg");
}
.headerPage {
  width: 100%;
  height: 65px;
  padding: 15px 25px;
  background-size: cover;
  z-index: 20;
  position: absolute;
}

.header-second {
  background: transparent !important;
}

.headerPage ul {
  display: flex;
  align-items: center;
  height: 100%;
}

.headerPage ul li {
  width: 50%;
  display: flex;
  flex: 1 1 auto;
  color: #fff !important;
  align-items: center;
}

.headerPage ul li:last-child {
  justify-content: flex-end;
}

.headerPage ul button .v-icon {
  color: #0000cd !important;
}

.titlePage {
  width: 100% !important;
  justify-content: center !important;
  display: flex;
}

.titlePage span {
  font-size: 12px;
  color: #0000cd;
  font-weight: bold;
}

.image-header-mobile {
  width: 100%;
  background-color: #fba800;
  padding: 20px 10px;
  text-align: right;
  display: flex;
  flex-direction: row;
  position: relative;
}

.text-header-mobile {
  font-size: 13px;
  text-align: right;
  margin-right: 10px;
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #0000cd;
}

.image-user {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid #fff;
}

.image-user img {
  width: 100%;
  height: 100%;
}

.nav-icon {
  display: flex;
  color: #0000cd;
}

.back-page button i {
  color: #0000cd !important;
  font-size: 25px !important;
}
.styl button {
  box-shadow: unset;
  background-color: unset !important;
}
.backPage {
  justify-content: flex-end;
}

.headerDetail {
  display: flex;
  margin-bottom: 8px;
}

.headerDetail span:first-child {
  width: 50px;
  display: block;
}

.user-name-header {
  margin-bottom: 20px;
}

.v-application ol,
.v-application ul {
  padding: 0 !important;
}

.v-overlay {
  z-index: 1 !important;
}

.theme--light.v-navigation-drawer {
  z-index: 999;
  height: 100vh !important;
}

.drawerInfo {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 16px;
}

.versionApp {
  display: block;
  width: 100%;
  text-align: center;
}

.v-list-item__title {
  margin-right: 16px;
  text-align: right;
}

.drawerInfo .v-list-item i {
  color: #fba800 !important;
}

.headerPage ul button {
  background-color: transparent !important;
  box-shadow: none;
}

.searchProduct .v-icon {
  color: #0000cd;
  font-size: 25px !important;
}

.v-badge {
  top: -10px;
  left: -30px;
  z-index: 99;
}

.headerPage ul button .v-badge i {
  color: #fff !important;
}

.basket-product
  .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background: none;
  box-shadow: none;
}

.headerPage ul button::before {
  opacity: 0 !important;
}

.headerPage ul button:active {
  box-shadow: none !important;
}

.headerPage ul button .v-ripple__container {
  display: none !important;
}

.search-Home .v-icon {
  font-size: 25px !important;
  color: #fff !important;
}

.backPage .v-btn span,
.backPage .v-btn .v-icon {
  color: #fff;
  align-items: center;
  display: flex;
}

.i.v-icon.notranslate.mdi.mdi-menu.theme--light {
  color: #fff !important;
}

.drawerInfo .v-list-item__titl:active,
.drawerInfo .v-list-item__titl:focus,
.drawerInfo .v-list-item__title {
  color: #0000cd !important;
}

.v-item-group {
  padding: 20px 0;
}

.v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.tellAban {
  text-decoration: none;
  display: flex;
  align-items: center;
}

.likeapp button i {
  font-size: 25px !important;
}

.searchBox {
  width: 1px;
  height: 1px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  overflow: hidden;
  opacity: 0;
  visibility: hidden;
  z-index: 10;
  background: #fff;
  border-radius: 100px;
  transition: all 0.3s;
  display: flex;
}

.searchBox button {
  width: 50px;
  box-shadow: none !important;
}

.searchBox .v-text-field.v-text-field--solo .v-input__control {
  min-height: 62px;
  box-shadow: none !important;
}

.searchBox .v-input__slot {
  box-shadow: none !important;
}

.activeSearch {
  width: 100%;
  height: 100%;
  border-radius: 0;
  visibility: visible;
  opacity: 1;
}

.seaerchResult {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #e0e0e0;
  z-index: 9;
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s;
  padding: 8px;
}

.showResult {
  opacity: 1;
  visibility: visible;
}

/*.itemResult {*/
/*    margin-bottom: 8px;*/
/*    background: #fff;*/
/*    display: flex;*/
/*}*/

.itemResult:first-child {
  margin-top: 70px;
}

.itemResult__image {
  width: 40px;
  height: 40px;
}

.itemResult__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.itemResult__title {
  display: flex;
  flex-direction: column;
}

.itemResult__title h5 {
  color: #000;
  margin: 0;
}

.itemResult__title span {
  color: #f4f4f4;
}

.brd-clr {
  border-bottom: 1px solid #fba800;
}

.v-list--nav {
  padding: 0 !important;
}

@media only screen and (max-width: 320px) {
  .headerPage {
    height: 50px;
  }

  .titlePage span {
    font-size: 10px;
  }

  .v-card-text {
    font-size: 12px;
  }

  .btnAction .v-btn {
    border-radius: 10px;
  }
}
</style>
